import Axios from "../helper/appConfig";

export const getGuestFormService = async (payload) => {
  const body = {
    search: [
      {
        searchfield: "status",
        searchvalue: "active",
        criteria: "eq",
      },
      {
        searchfield: "formname",
        searchvalue: "prospect",
        criteria: "eq",
      },
    ],
  };
    return Axios.post(`api/formfields/filter`, body);
};




export const createGuestService = async (payload) => {
    return Axios.post(`api/members`, payload);
};


export const validateGuestEmail = async (payload) => {
  return Axios.post(`api/common/validatedata/members/property.primaryemail`, payload);
};


export const communicationsSend = async (payload) => {
  return Axios.post(`api/communications/send`, payload);
};
